import { BasicCard, BasicCardProps } from '../basic-card';

export type WhoShouldBuyProps = {
  cards: BasicCardProps[];
  name: string;
};
export const WhoShouldBuy = (props: WhoShouldBuyProps) => {
  return (
    <div className="mt-12">
      <h3 className="lg:heading-3 heading-4">Who Should Buy {props.name}?</h3>
      <div className="mt-6 flex grid-cols-3 flex-col gap-x-4 gap-y-2 lg:grid lg:gap-y-3">
        {props.cards.map((card, idx) => {
          return <BasicCard {...card} key={idx} />;
        })}
      </div>
    </div>
  );
};

export default WhoShouldBuy;
